"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.34 6.694a1.807 1.807 0 0 0-2.484 0 1.6 1.6 0 0 0 0 2.326c.683.659 1.8.659 2.483 0a1.6 1.6 0 0 0 0-2.326M4.883 5.687a3.207 3.207 0 0 1 4.427 0 3 3 0 0 1 0 4.34 3.207 3.207 0 0 1-4.427 0 3 3 0 0 1 0-4.34m6.615 2.384a.7.7 0 0 1 .7-.7H17.3a.7.7 0 0 1 .7.7v2.143a.7.7 0 0 1-.7.7h-5.101a.7.7 0 0 1-.7-.7zm1.4.7v.743H16.6v-.743zm-1.4 3.5a.7.7 0 0 1 .7-.7h3.518a.7.7 0 0 1 .7.7v2.143a.7.7 0 0 1-.7.7h-3.518a.7.7 0 0 1-.7-.7zm1.4.7v.743h2.118v-.743zm-8.245 0c-.716 0-1.254.555-1.254 1.186v.343a.7.7 0 1 1-1.4 0v-.343c0-1.451 1.212-2.586 2.654-2.586H9.54a.7.7 0 1 1 0 1.4z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ResourceManagementIcon20.js.map